import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2p3pcs27: FaireBrandEntity = {
  token: "b_2p3pcs27",
  type: "brand",
  name: "Luv AJ",
  avatarUrl:
    "https://cdn.faire.com/fastly/6bd129b5392cda14332515b33cb46e59ec6313afa08b8ab62e46f81b27b3d004.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0388137b051de6a1b1583bd5b63d5f62bcac1a397eb0ccbe1020336f30e1520d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6bd129b5392cda14332515b33cb46e59ec6313afa08b8ab62e46f81b27b3d004.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0388137b051de6a1b1583bd5b63d5f62bcac1a397eb0ccbe1020336f30e1520d.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 23,
  isTopShop: true,
  isInsider: true,
  description:
    "Luv Aj is an affordable and fashion-forward jewelry brand specializing in classic everyday staples. It all began in 2005 when designer Amanda Thomas was a sophomore in high school and transformed her after-school hobby into her very own accessories line.\n\nOver the past two decades, Amanda has dedicated herself to creating a jewelry brand centered on unique, affordable, and high quality designs that don’t break the bank. Luv Aj has expanded into boutiques around the world and into major retailers like REVOLVE, Saks, Nordstrom, and KITH. Celebrities and it-girls like Bella Hadid, Hailey Bieber, and Kendall Jenner have become fans of Luv Aj's timeless and sparkly everyday pieces.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:55.862Z",
    importedBy: "entity-db-cli",
  },
};
